import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("学習データの編集")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "flex flex-col items-center w-3/4 mx-auto" }
const _hoisted_4 = { class: "text-gray-400" }
const _hoisted_5 = { class: "flex w-full mx-auto mb-6" }
const _hoisted_6 = { class: "mx-2 w-full" }
const _hoisted_7 = { class: "mx-2 w-full" }
const _hoisted_8 = { class: "flex w-full mx-auto mb-6" }
const _hoisted_9 = { class: "mx-2 w-full" }
const _hoisted_10 = { class: "mx-2 w-full" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "mb-2 text-red-500 text-xs" }, " ※ 学習開始日時には学習終了日時より未来の日時を入力してください ", -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "mb-2 text-red-500 text-xs" }
const _hoisted_15 = { class: "flex flex-col items-center w-3/4 mx-auto" }
const _hoisted_16 = { class: "flex flex-col items-center w-3/4 mx-auto" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 学習データを削除 ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 変更を保存 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_subjects_input = _resolveComponent("m-subjects-input")
  const _component_m_subjects_ratio_input = _resolveComponent("m-subjects-ratio-input")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "目標",
          goal: "goal",
          type: "text",
          placeholder: "目標を記入",
          value: _ctx.goal,
          entered: "",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goal = $event))
        }, null, 8, ["value"])
      ]),
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.learningRecordsText, (record, key) => {
          return (_openBlock(), _createBlock("div", {
            key: key,
            class: "w-full flex flex-col items-center rounded-md border-2 border-gray-200 px-3 py-2 mb-4"
          }, [
            _createVNode("span", _hoisted_4, _toDisplayString(key + 1) + "回目の入室", 1),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_m_text_field, {
                  label: "学習開始日",
                  name: "day",
                  type: "date",
                  placeholder: "2020/11/22",
                  entered: true,
                  value: record.startDate,
                  onInput: ($event: any) => (record.startDate = $event)
                }, null, 8, ["value", "onInput"])
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_m_text_field, {
                  label: "学習開始時間",
                  name: "time",
                  type: "time",
                  placeholder: "18:00",
                  entered: true,
                  value: record.startTime,
                  onInput: ($event: any) => (record.startTime = $event)
                }, null, 8, ["value", "onInput"])
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_m_text_field, {
                  label: "学習終了日",
                  name: "day",
                  type: "date",
                  placeholder: "2020/11/22",
                  entered: true,
                  value: record.endDate,
                  onInput: ($event: any) => (record.endDate = $event)
                }, null, 8, ["value", "onInput"])
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_m_text_field, {
                  label: "学習終了時間",
                  name: "time",
                  type: "time",
                  placeholder: "18:00",
                  entered: true,
                  value: record.endTime,
                  onInput: ($event: any) => (record.endTime = $event)
                }, null, 8, ["value", "onInput"])
              ])
            ]),
            (!_ctx.validRecord(record))
              ? (_openBlock(), _createBlock("div", _hoisted_11, [
                  _hoisted_12
                ]))
              : _createCommentVNode("", true),
            (!_ctx.validDatetimeConsistencyWithNextStartDatetime(record, key))
              ? (_openBlock(), _createBlock("div", _hoisted_13, [
                  _createVNode("p", _hoisted_14, " ※ 学習終了日時には、「" + _toDisplayString(key + 2) + "回目の入室」の学習開始日時より未来の日時は入力しないでください ", 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode(_component_m_subjects_input, {
          class: "w-3/4 mx-auto mb-6",
          subjects: _ctx.subjects,
          grade: _ctx.student.data.grade,
          onSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeSubjects($event)))
        }, null, 8, ["subjects", "grade"])
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode(_component_m_subjects_ratio_input, {
          subjects: _ctx.subjects,
          onUpdate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeSubjectsRatio($event)))
        }, null, 8, ["subjects"])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        color: "red-400",
        "hover-color": "red-500",
        outline: "",
        class: "mr-4",
        onClick: _ctx.deleteLearningData
      }, {
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.updateLearningData
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}